
import { defineComponent, PropType } from 'vue'
import { ElForm } from 'element-plus'
import { MESSAGE_TYPE_CONFIRM, MESSAGE_TYPE_TOAST, addMessageQueue } from '@/plugins/messageQueue'
import { CreateRequest } from '@/requests/boundaryStatus'
import JrButton from '@/components/jr-parts/JrButton.vue'
import { BoundaryStatusForm } from '@/types/forms'
import MessageService from '@/services/message'
import { BoundaryStatus } from '@/api'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'BoundaryStatusEditSend',
  components: {
    JrButton,
  },
  props: {
    BoundaryStatusForm: {
      type: Object as PropType<BoundaryStatusForm>,
      required: true,
    },
    formRef: {
      type: Object as PropType<InstanceType<typeof ElForm>>,
      required: false,
      default: null,
    },
    // 境界立会詳細ID
    boundaryId: {
      type: Number,
      required: true,
    },
    // 申請基本ID
    requestHeaderId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter()
    // 決定
    const save = () => {
      if (!props.formRef) {
        return
      }
      props.formRef.validate(async (valid) => {
        if (valid) {
          const statusForms: BoundaryStatus = {
            // 境界確認申請受付日
            boundary_confirm_applicant_receipt_date: props.BoundaryStatusForm
              .boundary_confirm_applicant_receipt_date_checked
              ? props.BoundaryStatusForm.boundary_confirm_applicant_receipt_date
              : null,
            // 調査開始日
            research_start_date: props.BoundaryStatusForm.research_start_date_checked
              ? props.BoundaryStatusForm.research_start_date
              : null,
            // 境界確認書受付日
            boundary_confirm_receipt_date: props.BoundaryStatusForm.boundary_confirm_receipt_date_checked
              ? props.BoundaryStatusForm.boundary_confirm_receipt_date
              : null,
            // 発送日
            send_date: props.BoundaryStatusForm.send_date_checked ? props.BoundaryStatusForm.send_date : null,
            // 用地管理システム登録日
            land_system_register_date: props.BoundaryStatusForm.land_system_register_date_checked
              ? props.BoundaryStatusForm.land_system_register_date
              : null,
          }

          // 確認ダイアログ表示
          addMessageQueue(MESSAGE_TYPE_CONFIRM, MessageService.codes.CONFIRM_SAVE, async () => {
            // OKなら送信する
            // requestの作成
            const request = new CreateRequest(props.boundaryId, statusForms)

            // API実行
            await request.exec()

            // API成功
            if (request.success) {
              addMessageQueue(
                MESSAGE_TYPE_TOAST,
                MessageService.bind(MessageService.codes.UPDATE_COMPLETE, { target: '境界立会状況' })
              )
              // OKなら詳細画面へ遷移する
              router.push({
                name: 'BoundaryDetail',
                params: {
                  request_header_id: props.requestHeaderId,
                },
              })
            }
          })
        }
      })
    }

    return {
      save,
    }
  },
})
